export const gamesConstants = {
    SET_GAMES: 'SET_GAMES',
    SET_GAME: 'SET_GAME',
    REMOVE_ITEM: 'REMOVE_GAME_ITEM',
};